/**
 * Nearest ancestor styled as a vertical scroll container, or null (the window).
 * Matched by overflow style alone — NOT current scrollHeight — because at mount
 * the content may not overflow yet (images still loading), and callers must still
 * bind to the real container rather than falling back to the window.
 */
const getScrollParent = (node: HTMLElement | null): HTMLElement | null => {
  let el = node?.parentElement ?? null;
  while (el) {
    const oy = window.getComputedStyle(el).overflowY;
    if (oy === 'auto' || oy === 'scroll' || oy === 'overlay') return el;
    el = el.parentElement;
  }
  return null;
};

export default getScrollParent;
